module.exports = __webpack_public_path__ + "img/language-map-c.fbc0c961.png";